import React from 'react';
import { FlexiflowComponent } from '@flexiflow-ui-kit/system';
import styled from 'styled-components';

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject, _templateObject2;
var NoScrollRelativeContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  overflow: hidden;\n"])), function (p) {
  return p.theme.predefinedCss.borderBoxChildren;
});
var ContentContainer = styled.main(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: auto;\n"])));

function PageContent(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(FlexiflowComponent, null, /*#__PURE__*/React.createElement(NoScrollRelativeContainer, null, /*#__PURE__*/React.createElement(ContentContainer, null, children)));
}

export { PageContent };
